export default __webpack_public_path__ + "static/media/shape3.9af07dcf.svg";